import React from 'react';

import image from '../assets/images/spinner.svg';

function Spinner(props) {
  return <img className={props.className} src={image} alt="Загрузка" />;
}

export default Spinner;
